import React from 'react';
import PropTypes from 'prop-types';

import CustomIcon from '../common/CustomIcon';
import PanelsBottomRowButton from '../common/PanelsBottomRowButton';

export default class DrawerCommonPanel extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.any,
    closePanel: PropTypes.func,
    panelHeaderTitle: PropTypes.any,
    hideRowButtons: PropTypes.bool,
    hidePrimaryButton: PropTypes.bool,
    disableButtons: PropTypes.bool,
    primaryButtonText: PropTypes.string,
    classes: PropTypes.string,
    onPrimaryButtonClick: PropTypes.func,
    outOfPaddingChildren: PropTypes.any,
    footerTopContent: PropTypes.any,
    showCancelButton: PropTypes.bool,
    handleSecondaryButtonClick: PropTypes.func,
    secondaryButtonClasses: PropTypes.string,
    secondaryButtonText: PropTypes.any,
    cancelButtonDanger: PropTypes.bool,
    icon: PropTypes.any,
    parentScrollHidden: PropTypes.bool
  };

  static defaultProps = {
    disableButtons: false,
    parentScrollHidden: false
  };

  renderBottomRowButton = () => {
    const {
      hideRowButtons,
      hidePrimaryButton,
      disableButtons,
      primaryButtonText,
      onPrimaryButtonClick,
      showCancelButton,
      handleSecondaryButtonClick,
      secondaryButtonText,
      icon,
      classes,
      secondaryButtonClasses,
      cancelButtonDanger
    } = this.props;
    const { footerTopContent } = this.props;
    return (
      <PanelsBottomRowButton
        hideRow={hideRowButtons}
        hidePrimaryButton={hidePrimaryButton}
        disableButtons={disableButtons}
        topContent={footerTopContent}
        classes={classes}
        primaryButtonText={primaryButtonText}
        cancelButtonText={secondaryButtonText}
        showCancelButton={showCancelButton}
        secondaryButtonClasses={secondaryButtonClasses}
        cancelButtonDanger={cancelButtonDanger}
        handleSecondaryButtonClick={handleSecondaryButtonClick}
        handlePrimaryButtonClick={onPrimaryButtonClick}
        icon={icon}
      />
    );
  };

  renderHeader() {
    const { closePanel, panelHeaderTitle } = this.props;

    return (
      <div className="drawer-header">
        <span className="drawer-header-cursor">
          <CustomIcon onClick={closePanel} name="close-button" size={24} />
        </span>
        <div className="drawer-header-title">{panelHeaderTitle}</div>
      </div>
    );
  }

  render() {
    // className is an styled-component prop to override styles
    const { children, outOfPaddingChildren, classes, className, parentScrollHidden } = this.props;

    return (
      <div className={`content-panel ${parentScrollHidden ? 'no-scroll' : ''}`}>
        <div className={`${classes} content ${className}`}>
          {this.renderHeader()}
          {children}
        </div>
        {outOfPaddingChildren ? outOfPaddingChildren : null}
        {this.renderBottomRowButton()}
      </div>
    );
  }
}
